import React, { useState } from "react";
import hotel1 from "../assets/images/hotel1.webp";
import hotel2 from "../assets/images/hotel2.webp";
import hotel3 from "../assets/images/hotel3.webp";

const hotels = [
  {
    city: "Thailand",
    title: "Wyndham Grand Phuket Kalim",
    location: "Thailand",
    guests: "2 Guests",
    duration: "3 Nights",
    rating: "5.0",
    oldPrice: "₹43,636",
    price: "₹40,000",
    image: hotel1,
    href:"/contact"
  },
  {
    city: "India",
    title: "Six Senses Fort Barwara",
    location: "India",
    guests: "2 Guests",
    duration: "4 Nights",
    rating: "4.9",
    oldPrice: "₹65,455",
    price: "₹60,000",
    image: hotel2,
    href:"/contact"
  },
  {
    city: "United Kingdom",
    title: "The Manor House Inn",
    location: "United Kingdom",
    guests: "2 Guests",
    duration: "5 Nights",
    rating: "4.9",
    oldPrice: "₹1,59,273",
    price: "₹1,46,000",
    image: hotel3,
    href:"/contact"
  },
];

function HotelBooking() {
  const [likedCards, setLikedCards] = useState([]);

  const toggleWishlist = (index) => {
    setLikedCards((prev) =>
      prev.includes(index)
        ? prev.filter((item) => item !== index)
        : [...prev, index],
    );
  };

 const handleExplore = (destination) => {
  window.dispatchEvent(
    new CustomEvent("open-agent-modal", {
      detail: destination,
    })
  );
};

  return (
    <section className="w-full px-4 py-12 sm:px-6 lg:px-8 lg:pb-16">
      <div className="mx-auto max-w-7xl">
        <div className="relative overflow-hidden rounded-[28px] border border-[#2E7D32]/10 bg-gradient-to-br from-[#F2FAF3] via-[#F5FBF5] to-[#EEF8F0] px-5 py-7 shadow-[0_20px_60px_rgba(46,125,50,0.10)] sm:px-7 lg:px-9 lg:py-6">
          <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#66BB6A]/10 blur-3xl" />

          <div className="pointer-events-none absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[#A5D6A7]/20 blur-3xl" />

          <div className="pointer-events-none absolute left-1/2 top-0 h-px w-[70%] -translate-x-1/2 bg-gradient-to-r from-transparent via-white to-transparent" />

          <div className="relative z-10 grid grid-cols-1 items-center gap-8 xl:grid-cols-[1fr_310px] xl:gap-9">
            <div className="grid grid-cols-1 md:gap-3 gap-8 md:grid-cols-2 xl:grid-cols-3">
              {hotels.map((hotel, index) => {
                const liked = likedCards.includes(index);

                return (
                  <a href={hotel.href}
                    key={`${hotel.title}-${index}`}
                    // onClick={() => handleExplore(hotel)}
                    className="cursor-pointer group relative overflow-hidden rounded-[20px] border border-white/80 bg-white shadow-[0_10px_30px_rgba(46,125,50,0.09)] transition-all duration-500 hover:-translate-y-2 hover:border-[#2E7D32]/25 hover:shadow-[0_20px_40px_rgba(46,125,50,0.16)]"
                  >
                    {/* IMAGE */}

                    <div className="relative h-[205px] overflow-hidden">
                      <img
                        src={hotel.image}
                        alt={hotel.title}
                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                      />

                      <div className="absolute inset-0 bg-gradient-to-t from-[#071B0B]/45 via-transparent to-transparent" />

                      <div className="absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-white/20 to-transparent" />

                      <div className="pointer-events-none absolute -left-[100%] top-0 h-full w-[50%] rotate-[18deg] bg-gradient-to-r from-transparent via-white/20 to-transparent transition-all duration-1000 group-hover:left-[130%]" />

                    </div>

                    {/* CARD CONTENT */}

                    <div className="px-2 pt-4">
                      {/* LOCATION + RATING */}

                      <div className="mb-3 flex items-center justify-between gap-2">
                        <div className="flex min-w-0 items-center gap-2 text-[14px] font-medium text-slate-700">
                          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#2E7D32]/10">
                            <i className="las la-map-marker text-base text-[#2E7D32]" />
                          </span>
                          <span className="truncate">{hotel.location}</span>
                        </div>

                        {/* RATING */}

                        <div className="flex items-center gap-1.5 text-[14px] font-medium text-[#668B28]">
                          <i className="las la-star text-base text-[#A8C94A]" />
                          {hotel.rating}
                        </div>
                      </div>

                      {/* TITLE */}

                      <h3 className="min-h-[38px] text-[16px] font-bold leading-[1.35] tracking-[-0.3px] text-[#12344A] transition-colors duration-300">
                        {hotel.title}
                      </h3>

                      {/* HOTEL DETAILS */}

                      {/* <div className="-mt-2 flex items-center gap-4 text-[12px] font-semibold text-slate-700">
                        <span className="flex items-center gap-1">
                          <i className="lar la-calendar text-lg text-[#2E7D32]" />
                          {hotel.duration}
                        </span>

                        <span className="flex items-center gap-1">
                          <i className="las la-user-friends text-lg text-[#2E7D32]" />
                          {hotel.guests}
                        </span>
                      </div> */}

                      {/* <div className="my-2 border-t border-slate-100" /> */}

                      {/* <div className="flex items-center justify-between gap-2 pb-4">

                        <div>
                          <div className="flex items-center gap-2">
                            <span className="text-[21px] font-bold tracking-[-0.5px] text-[#12344A]">
                              {hotel.price}
                            </span>
                          </div>

                          <p className="text-[9px] font-semibold text-slate-400">
                            per room / stay
                          </p>
                        </div>

                        <a
                          href="/about"
                          className=" group inline-flex items-center gap-4 rounded-lg bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6] px-3 py-2 text-[11px] font-bold tracking-[0.6px] text-white shadow-[0_10px_25px_rgba(1,158,231,0.20)] transition-all duration-300 "
                        >
                          <span>Book Now</span>

                          <span className="flex h-6 w-6 items-center justify-center rounded-md bg-white/15 transition-all duration-300 group-hover:translate-x-1">
                            <i className="las la-arrow-right text-[14px]" />
                          </span>
                        </a>
                      </div> */}
                      <div className="mb-3 mt-2 overflow-hidden rounded-2xl border border-[#019EE7]/20 bg-white shadow-[0_4px_20px_rgba(1,158,231,0.06)]">
                        <div className="relative overflow-hidden rounded-[16px] bg-white">
                          <div className="grid grid-cols-4">
                            <div className="group relative flex h-[82px] min-w-0 flex-col items-center justify-center px-1">
                              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-[#019EE7]/15 bg-gradient-to-br from-[#019EE7]/[0.10] to-[#97BF49]/[0.07] text-[#019EE7] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:scale-105">
                                <i className="las la-tag text-[18px]" />
                              </div>
                              <span className="mt-2 block w-full truncate text-center text-[9px] font-semibold leading-[11px] tracking-[0.1px] text-slate-600 group-hover:text-[#019EE7]">
                                Best Price
                              </span>
                              <span className="absolute right-0 top-1/2 h-7 w-px -translate-y-1/2 bg-gradient-to-b from-transparent via-[#019EE7]/15 to-transparent" />
                            </div>
                            <div className="group relative flex h-[82px] min-w-0 flex-col items-center justify-center px-1">
                              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-[#97BF49]/20 bg-gradient-to-br from-[#97BF49]/[0.12] to-[#019EE7]/[0.06] text-[#759F2F] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:scale-105">
                                <i className="las la-bed text-[18px]" />
                              </div>
                              <span className="mt-2 block w-full truncate text-center text-[9px] font-semibold leading-[11px] tracking-[0.1px] text-slate-600 group-hover:text-[#759F2F]">
                                Comfort
                              </span>
                              <span className="absolute right-0 top-1/2 h-7 w-px -translate-y-1/2 bg-gradient-to-b from-transparent via-[#019EE7]/15 to-transparent" />
                            </div>
                            <div className="group relative flex h-[82px] min-w-0 flex-col items-center justify-center px-1">
                              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-[#019EE7]/15 bg-gradient-to-br from-[#019EE7]/[0.10] to-[#97BF49]/[0.07] text-[#019EE7] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:scale-105">
                                <i className="las la-key text-[18px]" />
                              </div>
                              <span className="mt-2 block w-full truncate text-center text-[9px] font-semibold leading-[11px] tracking-[0.1px] text-slate-600 group-hover:text-[#019EE7]">
                                 Check in/out
                              </span>
                              <span className="absolute right-0 top-1/2 h-7 w-px -translate-y-1/2 bg-gradient-to-b from-transparent via-[#019EE7]/15 to-transparent" />
                            </div>
                            <div className="group relative flex h-[82px] min-w-0 flex-col items-center justify-center px-1">
                              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-[#97BF49]/20 bg-gradient-to-br from-[#97BF49]/[0.12] to-[#019EE7]/[0.06] text-[#759F2F] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:scale-105">
                                <i className="las la-concierge-bell text-[18px]" />
                              </div>
                              <span className="mt-2 block w-full truncate text-center text-[9px] font-semibold leading-[11px] tracking-[0.1px] text-slate-600 group-hover:text-[#759F2F]">
                                Hospitality
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>
            <div className="flex flex-col justify-center">
              <div className="mb-4 inline-flex w-fit items-center gap-2 rounded-full border border-[#2E7D32]/15 bg-white/70 px-3 py-1.5 text-[13px] font-extrabold text-[#2E7D32] shadow-sm backdrop-blur-xl">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#2E7D32]/10">
                  <i className="las la-hotel text-[17px] text-[#2E7D32]" />
                </span>
                Premium Hotel Stays
              </div>

              <h2 className="text-[34px] font-bold leading-[1.1] tracking-[0.2px] text-[#12344A] sm:text-[42px] lg:text-4xl">
                Stay Somewhere
                <span className="block">
                  <span>Beautiful</span>
                </span>
              </h2>

              <p className="mt-4 max-w-[350px] text-[15px] leading-6 text-slate-500 sm:text-base">
                Discover handpicked hotels, luxurious stays, and exceptional
                experiences in the world’s most beautiful destinations. From
                relaxing escapes to unforgettable getaways, find a stay designed
                around you.
              </p>

              <div className="mt-7">
                <a href="/contact"
                  className="group inline-flex items-center justify-center gap-3 rounded-lg bg-gradient-to-r from-[#1B5E20] via-[#2E7D32] to-[#66BB6A] px-6 py-2.5 text-[16px] font-bold text-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_32px_rgba(46,125,50,0.35)]"
                >
                  <span>Explore All Hotels</span>

                  <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/15 transition-all duration-300 group-hover:translate-x-1 group-hover:bg-white/25">
                    <i className="las la-arrow-right text-lg" />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HotelBooking;
